/**
 * 脚手架定义表状态管理
 *
 * @author PeterLee
 * @since 2026-06-04
 */
const state = {
   //表单校验规则
   rules: {
      //脚手架名称
      name:[{
         required: true,
         message: '请输入脚手架名称',
         trigger: 'blur'
       },
         {
           min: 1,
           max: 128,
           message: '长度在 1 到 128 个字符',
           trigger: 'blur'
         }
       ],
      //脚手架编码
      code:[{
         required: true,
         message: '请输入脚手架编码',
         trigger: 'blur'
       },
         {
           min: 1,
           max: 64,
           message: '长度在 1 到 64 个字符',
           trigger: 'blur'
         }
       ],
      //版本号
      version:[{
         required: true,
         message: '请输入版本号',
         trigger: 'blur'
       },
         {
           min: 1,
           max: 32,
           message: '长度在 1 到 32 个字符',
           trigger: 'blur'
         }
       ],
      //描述
      description:[{
         required: false,
         message: '请输入描述',
         trigger: 'blur'
      },
        {
         min: 1,
         max: 500,
         message: '长度在 1 到 500 个字符',
         trigger: 'blur'
       }
      ],
      //状态
      state:[{
         required: true,
         message: '请选择状态',
         trigger: 'change'
       }],
   },
   //列信息
   columnInfo: {
       //脚手架名称
       name:{
            visible:true,
            label:"脚手架名称"
       },
       //脚手架编码
       code:{
            visible:true,
            label:"脚手架编码"
       },
       //版本号
       version:{
            visible:true,
            label:"版本号"
       },
       //脚手架描述
       description:{
            visible:true,
            label:"脚手架描述"
       },
       //脚手架压缩包存储路径
       scaffoldFilePath:{
            visible:true,
            label:"脚手架压缩包"
       },
       //关联模板包ID
       templatePackageId:{
            visible:true,
            label:"关联模板包"
       },
       //配置清单JSON
       configSchema:{
            visible:true,
            label:"配置清单JSON"
       },
       //环境清单JSON
       envRequirements:{
            visible:true,
            label:"环境要求JSON"
       },
       //状态
       state:{
            visible:true,
            label:"状态"
       },
   },
   //表格数据（查询结果）
   tableData: [],
   //共有数据条数（分页控件）
   totalCount: 0,
   //选项列表（列表下拉框选择）
   options: {
      templatePackageIdOptions: [],
   },
   //查询参数
   queryParams: {
      //当前页数（分页控件）
      currPage: 1,
      //每页条数（分页控件）
      limit: 10,
      //是否升序
      ascOrder: false,
      //排序字段
      orderField: "",
      //此处为可能需要修改部分，请不要忽略
      param: {
         //脚手架名称
         name: undefined,
         //脚手架编码
         code: undefined,
         //版本号
         version: undefined,
        //脚手架描述
        description: undefined,
        //配置清单JSON
        configSchema: undefined,
        //环境清单JSON
        envRequirements: undefined,
        //状态
        state: undefined,
      }
   },
   //时间范围
   dateRange: {
   },
   //表单组件信息
   formInfo: {
      //表单组件弹出框显示控制
      dialogVisible: false,
      //是否增加操作（非增加操作会隐藏部分操作）
      isAdd: false,
      //编辑回显数据
      editData: {},
   },
   //更多按钮信息
   moreButtonProps:[
      //{command:'test',label:'示例按钮',permissionCode:'itil:event'}
   ]
}
export default state
